import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {FormTO} from "../classes/form-to";
import {Observable, Subject} from "rxjs";
import {ForgotPasswordTO} from "../classes/forgot-password-to";
import {SessionTO} from "../classes/session-to";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _session = new Subject();
  session$ = this._session.asObservable();

  public setSession(sessionInfo: SessionTO) {
    this._session.next(sessionInfo);
  }

  constructor(private http: HttpClient) { }

  public processEmailAddress(emailAddress: String): Observable<Object> {
    return this.http.post('/rest/auth/email', emailAddress);
  }

  public loginProxy(username: string, password: string): Observable<Object> {
    const body = new HttpParams()
        .set('username', username)
        .set('password', password);

    // console.log('loginProxy: posting to /api/v1/login');

    return this.http.post('/api/v1/login',
        body.toString(),
        {
          responseType: 'json',
          headers: new HttpHeaders()
              .set('Content-Type', 'application/x-www-form-urlencoded')
              .set('Accept', 'application/json')
        }
    );
  }
  public logout(): Observable<Object> {
    return this.http.get('/logout');
  }

  public getLoginStatus(): Observable<Object> {
    return this.http.get('/rest/login/status');
  }

  public whoAmI(): Observable<Object> {
    return this.http.get('/rest/whoami');
  }

  public isAuth(): Observable<any> {
    return this.http.get('/rest/isAuth');
  }

  public sendForgotPasswordConfirmationCode(forgotPasswordTO: ForgotPasswordTO): Observable<Object> {
    return this.http.post('/rest/forgot/send', forgotPasswordTO);
  }

  public confirmForgotPasswordConfirmationCode(forgotPasswordTO: ForgotPasswordTO): Observable<Object> {
    return this.http.post('/rest/forgot/confirm', forgotPasswordTO);
  }

  public savePasswordChange(forgotPasswordTO: ForgotPasswordTO): Observable<Object> {
    return this.http.post('/rest/password', forgotPasswordTO);
  }
}
